module.exports = __webpack_public_path__ + "static/media/report-not-found.f54e00de.jpg";